/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import TWEEN from "@tweenjs/tween.js"
import Image from "../../objects/Image";
import R from "../../config/R";
import * as Events from "../../Events";
import {AnimationUtils} from "../../AnimationUtils";
import * as _ from "lodash";
import CustomAnimatedSprite from "../../objects/CustomAnimatedSprite";
import SoundManager from "../../SoundManager"

export class SpeechBubble extends PIXI.Container {
  constructor(x, y, resources){
    super()
    this.x = x
    this.y = y

    const bubble = new Image(0,0, resources[R.images.speechBubble.name].texture)
    const key = new Image(0,-20, resources[R.images.key.name].texture)

    this.addChild(bubble)
    this.addChild(key)

    this.alpha = 0
  }

  disappear(){
    return new TWEEN.Tween(this)
      .delay(2000)
      .to({alpha: 0}, 500)
      .easing(TWEEN.Easing.Quadratic.InOut)
      .onComplete(() => {

      })
  }

  appear(){
    return new TWEEN.Tween(this)
      .to({alpha: 1}, 500)
      .easing(TWEEN.Easing.Quadratic.InOut)
      .onComplete(() => {
        SoundManager.instance.playEffect(R.sounds.click1)
      })
  }

}



// WEBPACK FOOTER //
// ./src/game/characters/common/SpeechBubble.js